import React, { Component, Suspense } from 'react';
import { Button, Spin } from 'antd';

const placeholderStyle = {
  minHeight: 240,
  width: '100%',
  display: 'grid',
  placeItems: 'center',
  padding: 24,
  boxSizing: 'border-box',
};

class PageLoadErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (this.state.failed) {
      return (
        <div role="alert" style={placeholderStyle}>
          <div style={{ textAlign: 'center' }}>
            <p>页面暂时无法加载，请检查网络后刷新重试。</p>
            <Button onClick={() => window.location.reload()}>刷新页面</Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// No wrapper around loaded content: preserve each page's flex layout.
const PageLoadBoundary = ({ children, resetKey }) => (
  <PageLoadErrorBoundary resetKey={resetKey}>
    <Suspense fallback={
      <div role="status" style={placeholderStyle}>
        <div style={{ textAlign: 'center' }}>
          <Spin size="large" />
          <p style={{ marginTop: 12, marginBottom: 0, color: '#64748b', fontSize: 14 }}>正在加载页面…</p>
        </div>
      </div>
    }>
      {children}
    </Suspense>
  </PageLoadErrorBoundary>
);

export default PageLoadBoundary;
